module.exports = Object.freeze({
  STATUS_DRAFT: 'draft',
  STATUS_SUBMITTED: 'submitted',
  STATUS_WITHDRAWN: 'withdrawn',
  STATUS_ACCEPTED: 'accepted',
  STATUS_REJECTED: 'rejected',
  STATUS_COMPLETE: 'complete',
  statuses: [
    'STATUS_DRAFT',
    'STATUS_SUBMITTED',
    'STATUS_WITHDRAWN',
    'STATUS_ACCEPTED',
    'STATUS_REJECTED',
    'STATUS_COMPLETE',
  ],
  REF_SHORTCODE_PREFIX: 'CCJAPP',
  OFFICE_STATUS_REFERRED: 'referred',
  OFFICE_STATUS_NOT_SEEN: 'not-seen',
  OFFICE_STATUS_SEEN: 'seen',
  OFFICE_STATUS_CLOSED: 'closed',
  officeStatuses: [
    'OFFICE_STATUS_REFERRED',
    'OFFICE_STATUS_NOT_SEEN',
    'OFFICE_STATUS_SEEN',
    'OFFICE_STATUS_CLOSED',
  ],
  blankOffice: {
    status: null,
    assignedTo: {},
    notes: {
      rejection: null,
      general: null,
    },
  },
  blankInterviewDetails: {
    datetime: null,
    notes: null,
  },
  blankDbsDeclaration: {
    dbs1: '',
    dbs1notes: '',
    dbs2: '',
    dbs2notes: '',
    dbs3: '',
    dbs3notes: '',
    dbs4: '',
    dbs4notes: '',
    dbs5: '',
    dbs6: '',
    dbs7: '',
    dbs8: '',
  },
});
